<div>
  <app-table-component
    [cols]="cols"
    [data]="onlineCounterData()"
    [totalRecords]="sessionServiceRespone()?.totalElements"
    [loading]="tableLoading()"
    [searchable]="true"
    searchInputPlaceholder="Search Counter"
    (onChangePage)="onChangePage($event)"
    (searchFilter)="onSearchFilter($event)"
  ></app-table-component>

  <!-- Templates -->
  <ng-template #nameColumnTemplate let-rowData="rowData">
    <span class="font-bold">{{ rowData?.computerName }}</span>
    <span class="pl-2" *ngIf="rowData.isFirstTime">
      <i
        class="pi pi-question-circle !text-sm"
        pTooltip="No activity has been detected for the past {{ noActivityDays }} days."
      ></i>
    </span>
  </ng-template>

  <ng-template #appTypeColumnTemplate let-rowData="rowData">
    @switch (rowData?.serverPingInformation?.Url) {
      @case ('acente.flypgs.com') {
        <span>DCS</span>
      }
      @case ('pax.flypgs.com') {
        <span>DCS</span>
      }
      @case ('paxcontrol.flypgs.com') {
        <span>PAXCONTROL</span>
      }
      @case ('prep.flypgs.com') {
        <span>TEST</span>
      }
      @case ('pctest.flypgs.com') {
        <span>TEST</span>
      }
      @case ('dracente.flypgs.com') {
        <span>DR DCS</span>
      }
      @case ('drpax.flypgs.com') {
        <span>DR DCS</span>
      }
      @case ('fallback.flypgs.com') {
        <span>FALLBACK</span>
      }
      @default {
        <span>{{ rowData?.applicationType || '-' }}</span>
      }
    }
  </ng-template>

  <ng-template #loginDateTimeColumnTemplate let-rowData="rowData">
    <span>{{ rowData?.loginTime | date: 'dd.MM.yyyy | HH:mm' }}</span>
  </ng-template>

  <ng-template #statusColumnTemplate let-rowData="rowData">
    <div
      [class]="
        rowData.serverPingInformation?.Status === 'OFFLINE'
          ? 'status-indicator error'
          : 'status-indicator'
      "
    >
      <div
        [class]="
          rowData.serverPingInformation?.Status === 'OFFLINE' ? 'status-dot error' : 'status-dot'
        "
      ></div>
    </div>
  </ng-template>

  <ng-template #detailColumnTemplate let-rowData="rowData">
    <p-button outlined variant="text" severity="info" (onClick)="openDetailDialog(rowData)">
      Show Detail
    </p-button>
  </ng-template>

  <app-counter-detail />
</div>
